export enum DictationButtonStateEnum {
    DictationStarting,
    DictationOn,
    DictationStopping,
    DictationStopped,
}

export default DictationButtonStateEnum;
